import * as React from "react";
import * as _ from "lodash";
import {translate} from "react-i18next";
import {RouteComponentProps} from "react-router-dom";
import {connect} from "react-redux";
import {ITranslatedComponent, ITypefamilyMap} from "../../redux/reducers/generalReducer";

// view container
import ViewContainer from "../ViewContainer";

// services
import {
    CategoryTextDto,
    HistoryDto,
    LanguageDto,
    Link,
    MenuDto,
    ModelyearDto,
    OBCategoriesDto,
    OptionBasicDto,
    OptionBasicDtoOptionType,
    OptionBasicMYCopyConflictDto,
    OptionBasicMYCopyDto,
    OptionBasicMYCopySummaryDto,
    OptionBasicPSLDependencyDto,
    OptionInitDto,
    PDiPOptionBasicDto,
    ResourceListOfModelyearDto,
    ResourceListOfOptionBasicDto,
    RoleDto,
    TypefamilyDto,
    WorkflowDto,
    WorkflowStatusDtoType
} from "../../services/Client";
import HATEOASClient, {
    GetCategoryParams,
    GetOBDeleteDependencyParams,
    GetOBInitStatusParams,
    GetOBMYCopyStatusParams,
    GetWorkflowOptionParams,
    ICheckedRequestExecution
} from "../../services/HATEOASClient";
import ColumnFactory, {RegexFactory} from "../../services/ColumnFactory";
import {sortWorkflowsByName} from "../../services/WorkflowUtils";

// components
import {SelectableColumn} from "../../components/ColumnSelection";

import {loadColumns} from "./BaseOptionsViewSettings";
import ModelyearSelectDialog from "./ModelyearSelectDialog";
import BaseOptionsHeader from "./BaseOptionsHeader";
import BaseOptionsTableContainer from "./BaseOptionsTableContainer";
import SelectInitPslDialog from "./SelectInitPslDialog";
import InitPSLDialog from "./InitPslDialog";
import OptionBasicCreationDialog from "./OptionBasicCreationDialog";
import IBaseOptionsRow from "./BaseOptionsRow";
import {createDtoFromRow, createRowFromDto, createRowsFromResourceList,} from "./BaseOptionsRowUtils";
import {InitPSLOB, SelectedWorkflowOB, SelectWorkflowOB} from "../../components/Table/VirtualizedTableInterfaces";
import BaseOptionsMYCopyConflictDialog from "./BaseOptionsMYCopyConflictDialog";
import Dialog from "../../components/Dialogs/Dialog";
import Button from "../../components/Button";
import {InfoDetails, renderErrorToast, renderInfoToast, renderWarningToast} from "../../utils/FeedbackMessageUtils";
import {BaseOptionsDeleteConfirmDialog} from "./BaseOptionsDeleteConfirmDialog";
import {ITableSort, sortOptions} from "../../utils/SortUtils";
import ErrorBoundary from "../../utils/ErrorBoundary";
import GeneralActions from "../../redux/actions/GeneralActions";
import BaseOptionViewActions from "../../redux/actions/BaseOptionViewActions";
import {compose, Dispatch} from "redux";
import {IUserSettings} from "../../data/IUserSettings";
import {IApplicationLink} from "../../data/IApplicationLink";
import {
    selectBaseLinks,
    selectBaseOptionsAreaExtraLinks,
    selectClient,
    selectLanguage,
    selectLanguageList,
    selectLoadingMessages,
    selectOptionBasicsPDiPList,
    selectOptionBasicTableSort,
    selectSwitchHeaderMode,
    selectUserModelyears,
    selectUserRoles,
    selectUserSettings,
    selectUserTypefamiliesMap,
    selectVirtualizedTableSelectedIdList,
    selectWorkflows
} from "../../redux/selectors";
import {ILocationTranslation, ITextAndIcon} from "src/components/GeneralInterfaces";
import {IError} from "src/components/FeedbackMessage";
import {IReduxState} from "src/redux/IReduxState";
import {HistoryDialog} from "../../components/Dialogs/HistoryDialog";
import {LanguageCodeEnum} from "../AdminView/LanguageTab/LanguageTable";
import {VIEWNAME} from "../../utils/GeneralUtils";
import {PCCDSyncDialog} from "../common/PCCDSyncDialog";

interface IMapDispatchToProps {
    addTranslationLocation: (translation: ILocationTranslation) => void;
    setSelectedIdLists: (ids: string[]) => void;
    addRecentDocument: (appLink: IApplicationLink) => void;
    getWorkflows: () => void;
    receiveOBExtraLinks: (links: MenuDto) => void;
    setTableSort: (sort: ITableSort) => void;
    setSerCatgories: (dtos: CategoryTextDto[]) => void;
    setNonSerCatgories: (dtos: CategoryTextDto[]) => void;
    setDynTableReload: (flag: boolean) => void;
    addLoadingMessage: (message: string) => void;
    removeLoadingMessage: (message: string) => void;
    getOBPDiPList: (menuDto: MenuDto, mj4: number) => void;
}

interface IMapStateToProps {
    userSettings: IUserSettings;
    baseLinks?: MenuDto;
    optionBasicTableSort: ITableSort;
    languageList?: LanguageDto[];
    workflows?: WorkflowDto[];
    userModelyears: ResourceListOfModelyearDto;
    client: HATEOASClient;
    baseOptionsAreaExtraLinks: MenuDto;
    userRoles?: RoleDto[];
    dynTableSelectedIdList: string[];
    userTypefamiliesMap: ITypefamilyMap;
    optionBasicsPDiPList: PDiPOptionBasicDto[];
    loadingMessages?: String[];
    switchHeaderMode: boolean;
    userLanguage: string;
}

interface IOwnProps {

}

interface IBaseOptionViewProps extends IMapStateToProps, IMapDispatchToProps, IOwnProps, ITranslatedComponent, RouteComponentProps<any> {
}

interface IBaseOptionViewState {
    /** Tab index of the ModelyearSelectDialog or undefined to hide the dialog. */
    modelyearDialogIndex: number | undefined;

    /** Selected model year to be displayed. */
    selectedModelyear?: ModelyearDto;

    /** Whether or not to show the selection dialog for initiliazing OBs. */
    showPslCreationDialog: boolean;

    /** Whether or not to show the init PSL overview dialog. */
    showInitPSLOBDialog: boolean;

    /** Whether or not to show the option basic creation dialog. */
    showOptionBasicCreationDialog: boolean;

    /** Whether or not to show the 'switch-to-new-modelyear' dialog. */
    modelyearCopyResultDialog?: JSX.Element;

    /**  */
    modelyearCopyConflictStatusDialog?: JSX.Element;

    /** Whether or not the tables are in 'edit' mode (default: false) */
    editMode: boolean;

    /** All available columns for the tables. */
    columns: SelectableColumn[];

    /** All rows that can be passed to BaseOptionsTableContainer. */
    rows: IBaseOptionsRow[];

    /** All rows that are currently selected. */
    selectedRows: IBaseOptionsRow[];

    /** Request object to create new option basic */
    postRequest?: ICheckedRequestExecution<OptionBasicDto, OptionBasicDto>;

    /** Request object to get delete dependencies for a list of basic options */
    getDeleteDependencyRequest?: ICheckedRequestExecution<ResourceListOfOptionBasicDto, GetOBDeleteDependencyParams>;

    /** Option basic PSL dependencies(for constraint/exclusion/package content) */
    deleteDependencies?: {[key: number]: OptionBasicPSLDependencyDto};

    /** Whether or not to show the delete confirm dialog. */
    showDeleteOBConfirmDialog: boolean;

    /** Dtos selected for delete */
    forDeleteDtos?: OptionBasicDto[];

    /** Object for InitPSLDialog */
    initPSLOB?: InitPSLOB;

    /** contains the links of the resource list */
    resourceLinks?: MenuDto;

    /** Show the history dialog */
    isShowHistoryDialog: boolean;

    /** Contains the history data for a selected item */
    selectedItemHistoryData?: HistoryDto[];

    fieldKeyFilters: Set<string>;

    /** Contains the filtered history data for a selected item */
    selectedItemFilteredHistoryData?: HistoryDto[];
    optionTypes: string[];
    failedTodelete: number;
    showCheckPCCDSyncResultDlg: boolean;
    checkPCCDSyncResult?: any;
}

const createReadableLinkForBaseOptionsView = (text: string, state: IReduxState): ITextAndIcon => {
    const {general} = state;
    const modelyearObjectId = parseInt(text, 10);
    if (general.userModelyears.elements) {
        const modelyear = general.userModelyears.elements.find((dto) => dto.objectId === modelyearObjectId);
        if (modelyear) {
            text = ColumnFactory.mj2str(modelyear);
        }
    }
    return {text: "MODELYEAR_VALUE", options: {value: text}};
};

class BaseOptionView extends React.Component<IBaseOptionViewProps, IBaseOptionViewState> {

    processOBInitMsg: string = this.props.t("BASEOPTIONS:PROCESS_INIT_PSL_MSG");
    standardCategories?: CategoryTextDto[] | undefined;
    nonSerCategories?: CategoryTextDto[] | undefined;

    constructor(props: IBaseOptionViewProps) {
        super(props);
        const settings = this.props.userSettings.baseOptionsView;

        this.state = {
            modelyearDialogIndex: undefined,
            showPslCreationDialog: false,
            showInitPSLOBDialog: false,
            showOptionBasicCreationDialog: false,
            showDeleteOBConfirmDialog: false,
            modelyearCopyResultDialog: undefined,
            editMode: false,
            columns: loadColumns(settings),
            rows: [],
            selectedRows: [],
            postRequest: undefined,
            resourceLinks: undefined,
            isShowHistoryDialog: false,
            selectedItemHistoryData: undefined,
            fieldKeyFilters: new Set<string>(),
            optionTypes: [],
            failedTodelete: 0,
            showCheckPCCDSyncResultDlg: false
        };
    }

    componentDidMount() {
        this.props.addTranslationLocation({pattern: "optionbasic", substitutes: "OPTION_BASIC"});
        this.props.addTranslationLocation({
            pattern: new RegExp("optionbasic\/(.+)($|\/)"),
            substitutes: [{
                substitute: (text: string, state: IReduxState) => {
                    return createReadableLinkForBaseOptionsView(text, state);
                }
            }]
        });

        if (this.props.baseLinks) {
            this.requestBaseOptionExtraLinks(this.props.baseLinks);
        }
    }

    componentDidUpdate(prevProps: Readonly<IBaseOptionViewProps>): void {
        if (prevProps.optionBasicTableSort.thirdKey !== this.props.optionBasicTableSort.thirdKey
            || prevProps.optionBasicTableSort.thirdKeyAsc !== this.props.optionBasicTableSort.thirdKeyAsc
            || prevProps.optionBasicTableSort.intSequence !== this.props.optionBasicTableSort.intSequence
            || prevProps.optionBasicTableSort.categoryText !== this.props.optionBasicTableSort.categoryText
        ) {
            this.setState(
                {
                    rows: sortOptions(this.state.rows, this.props.optionBasicTableSort),
                    selectedRows: [],
                },
                () => this.props.setSelectedIdLists([])
            );
        }
    }

    componentWillReceiveProps(newProps: IBaseOptionViewProps) {
        if (this.props.userSettings.baseOptionsView.optionBasicColumns === undefined &&
            newProps.userSettings.baseOptionsView.optionBasicColumns !== undefined) {
            // user settings have been loaded; recreate the columns from settings
            const newColumns = loadColumns(newProps.userSettings.baseOptionsView);
            this.setState({columns: newColumns});
        }

        // wait until the required data was received in the global store.
        // don't attempt to request option basic data before that.
        const {languageList, workflows} = this.props;
        if (!languageList || !workflows) {
            return;
        }

        const {selectedModelyear} = this.state;
        const modelyearUrlParam = newProps.match.params.modelyear;
        const modelyears = newProps.userModelyears.elements || [];
        const modelyearFromUrl = this.getModelyearFromParamInternal(modelyearUrlParam, modelyears);
        if (modelyearFromUrl) {
            if (!selectedModelyear || (modelyearFromUrl.objectId !== selectedModelyear.objectId)) {
                // the model year in the link is different from what's currently selected;
                // request the options basic data for it the new model year.
                this.props.addRecentDocument({
                    href: `/optionbasic/${modelyearFromUrl.objectId}`,
                    description: `BASE_OPTIONS_MY_LINK/${ColumnFactory.mj2str(modelyearFromUrl)}`
                });
                this.requestOptionsBasicResource(modelyearFromUrl);
                this.props.getWorkflows();
                this.setState({selectedModelyear: modelyearFromUrl});
            }
        }
    }

    requestBaseOptionExtraLinks = (baseLinks: MenuDto) => {
        if (this.props.client.GET_optionBasicExtraLinks(baseLinks).canExecute()) {
            this.props.client.GET_optionBasicExtraLinks(baseLinks).execute()
                .then((extraLinks: MenuDto) => {
                    this.props.receiveOBExtraLinks(extraLinks);
                })
                .catch((reason) => {
                    window.scrollTo(0, 0);
                    renderErrorToast({
                        message: "ERRORS:GET_BASE_OPTIONS_AREA_EXTRA_LINKS",
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }
    }

    componentWillUnmount(): void {
        this.props.setTableSort({categoryText: true, intSequence: true});
    }

    getModelyearFromParam = (): ModelyearDto | undefined => {
        const param = this.props.match.params.modelyear;
        const modelyears = this.props.userModelyears.elements || [];
        return this.getModelyearFromParamInternal(param, modelyears);
    }

    getModelyearFromParamInternal = (param: string, modelyears: ModelyearDto[]): ModelyearDto | undefined => {
        if (param) {
            const modelyearObjectId = parseInt(param, 10);
            const modelyear = modelyears.find(dto => modelyearObjectId === dto.objectId);
            if (modelyear) {
                return modelyear;
            }
        }

        return undefined;
    }

    requestOBCategories(links: MenuDto | undefined, modelyearId: number, language: LanguageDto | undefined): void {
        if (language && links) {
            let categoryParams: GetCategoryParams = {
                modelyear: modelyearId.toString(),
                language: language.objectId.toString(),
            };
            const getCategoriesRequest = this.props.client.GET_OBCategories(links);
            if (getCategoriesRequest.canExecute()) {
                getCategoriesRequest.execute(categoryParams)
                    .then((response: OBCategoriesDto) => {
                        this.standardCategories = response.serCategories;
                        this.nonSerCategories = response.nonSerCategories;
                        if ((!this.standardCategories
                            || this.standardCategories.length === 0)
                            && (!response.nonSerCategories
                                || response.nonSerCategories.length === 0)
                        ) {
                            renderErrorToast({
                                message: "ERRORS:GET_CATEGORIES",
                                details: "ERRORS:EMPTY_CATEGORIES",
                                timestamp: Date.now()
                            });
                        }
                        else {
                            this.props.setSerCatgories(this.standardCategories);
                            this.props.setNonSerCatgories(response.nonSerCategories);
                        }
                    }).catch((reason) => {
                        renderErrorToast({
                            message: "ERRORS:GET_CATEGORIES",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            }
        }
        else if (!language) {
            renderErrorToast({
                message: "ERRORS:GET_SER_CATEGORIES",
                details: this.props.t("ERRORS:INVALID_LANGUAGE_DETAILS", {langId: this.props.userSettings.language}),
                translatedDetails: true,
                timestamp: Date.now()
            });
        }
    }

    requestOptionsBasicResource = (modelyear: ModelyearDto) => {
        if (!this.props.client.GET_optionBasicList(modelyear).canExecute()) {
            renderErrorToast({
                message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });
            return;
        }
        this.props.setDynTableReload(true);

        const loadingMsg = this.props.t("LOADING_VALUE", {value: ColumnFactory.mj2str(modelyear)});
        this.props.addLoadingMessage(loadingMsg);

        this.props.client.GET_optionBasicList(modelyear).execute({computePdipFlag: true, computePCCDFlag: true, metadata: true})
            .then((value: ResourceListOfOptionBasicDto) => {
                const {languageList, workflows} = this.props;
                const menuDtoLinks = {links: value.links} as MenuDto;
                let language;

                if (value.elements && value.links && languageList && workflows) {
                    const rows = createRowsFromResourceList(value, languageList, workflows);
                    const post = this.props.client.POST_optionBasic(value);
                    const getDeleteDependencyRequest = this.props.client.GET_optionBasicDependency(value);
                    this.props.setSelectedIdLists([]);
                    this.props.setDynTableReload(false);

                    if (this.props.userSettings.language === 'de') {
                        language = languageList.find(val => val.vmce === LanguageCodeEnum.BASIC_GERMAN.toString());
                    } else {
                        language = languageList.find(val => val.vmce === LanguageCodeEnum.BASIC_ENGLISH.toString());
                    }

                    this.requestOBCategories(
                        menuDtoLinks,
                        modelyear.objectId,
                        language);
                    const obRows = sortOptions(rows, this.props.optionBasicTableSort);
                    this.setState(
                        {
                            rows: obRows,
                            selectedRows: [],
                            postRequest: post.canExecute() ? post : undefined,
                            getDeleteDependencyRequest: getDeleteDependencyRequest.canExecute() ? getDeleteDependencyRequest : undefined,
                            resourceLinks: menuDtoLinks
                        },
                        () => this.state.postRequest &&
                            this.state.postRequest.canExecute() &&
                            this.state.resourceLinks &&
                            this.props.getOBPDiPList(this.state.resourceLinks, modelyear.mj4)
                    );
                    setTimeout(
                        ()=>this.setState({rows:obRows}),
                        1000
                    );
                    setTimeout(
                        ()=>this.props.removeLoadingMessage(loadingMsg),
                        2000
                    );
                }
            })
            .catch((reason) => {
                this.props.removeLoadingMessage(loadingMsg);
                renderErrorToast({
                    message: "ERRORS:GET_BASIC_OPTIONS",
                    details: reason,
                    timestamp: Date.now()
                });
                this.setState({selectedRows: []});
            });
    }

    addOptionBasic = (dto: OptionBasicDto): void => {
        const loadingMsg = this.props.t("ADD_OPTION_BASIC");
        this.props.addLoadingMessage(loadingMsg);

        if (!dto.intSequence)
            dto.intSequence = 9999;

        if (this.state.postRequest) {
            this.state.postRequest.execute(dto)
                .then((value: OptionBasicDto) => {
                    if (value != null) {
                        const modelyear = this.props.userModelyears.elements ?
                            this.props.userModelyears.elements.find((my) => my.objectId === value.modelyear.objectId) : undefined;
                        const mj4 = modelyear ? modelyear.mj4 : 'objectId<' + value.modelyear.objectId + '>';

                        const infoDetails: InfoDetails = {
                            response: {
                                status: 200,
                                statusText: "CREATED",
                                message: this.props.t("INFO:NEW_OPTION_BASIC", {optionCode: value.optionCode, optionType: value.optionType, modelyear: mj4}),
                            }
                        };

                        this.props.removeLoadingMessage(loadingMsg);
                        renderInfoToast({
                            message: "INFO:OPTION_BASIC_CREATED",
                            details: infoDetails,
                            timestamp: Date.now()
                        });
                    }

                    if (this.state.selectedModelyear) {
                        this.requestOptionsBasicResource(this.state.selectedModelyear);
                    }
                })
                .catch((reason) => {
                    this.props.removeLoadingMessage(loadingMsg);
                    renderErrorToast({
                        message: "ERRORS:CREATE_OPTION_BASIC",
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }
    }

    private refreshResources() {
        if (this.state.selectedModelyear) {
            this.requestOptionsBasicResource(this.state.selectedModelyear);
            this.props.getWorkflows();
        }
    }

    updateOptionBasic = (oldRow: IBaseOptionsRow, newRow: IBaseOptionsRow, rowIndex: number): void => {
        const newDto: OptionBasicDto = createDtoFromRow(newRow);
        if (newDto.intSequence === 9999)
            newDto.intSequence = oldRow.optionBasicDto.intSequence;
        const patchRequest = this.props.client.PATCH_optionBasic(newDto);
        if (!patchRequest.canExecute()) {
            renderErrorToast({
                message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });
            return;
        }

        // apply regex check when the option code is updated
        if (oldRow.optionCode !== newRow.optionCode && !newRow.optionCode.match(RegexFactory.regex.updateOptionCode)) {
            renderErrorToast({
                message: 'ERRORS:OPTION_CODE_UPDATE_REGEX',
                timestamp: Date.now(),
            });
            this.refreshResources();
            return;
        }

        const loadingMsg = this.props.t("UPDATE_OPTION_BASIC");
        this.props.addLoadingMessage(loadingMsg);

        patchRequest.execute(newDto)
            .then((link: Link) => {
                // reload the tables if and only if the option type changed from or to SER.
                const forceReload =
                    newRow.optionType !== oldRow.optionType && (
                        newRow.optionType === OptionBasicDtoOptionType.SER ||
                        oldRow.optionType === OptionBasicDtoOptionType.SER
                    );

                if (forceReload) {
                    this.props.removeLoadingMessage(loadingMsg);
                    this.refreshResources();
                } else {
                    const getRequest = this.props.client.GET_optionBasic(link);
                    if (!getRequest.canExecute()) {
                        return;
                    }
                    getRequest.execute()
                        .then((updatedDto: OptionBasicDto) => {
                            const {languageList, workflows} = this.props;
                            if (languageList && workflows) {
                                const updatedRow = createRowFromDto(updatedDto, languageList, workflows);
                                let updatedRows = this.state.rows.slice();

                                updatedRows[rowIndex] = updatedRow;
                                updatedRows = sortOptions(updatedRows, this.props.optionBasicTableSort);

                                this.setState({rows: updatedRows});
                                this.props.removeLoadingMessage(loadingMsg);
                            }
                        })
                        .catch((reason) => {
                            this.props.removeLoadingMessage(loadingMsg);
                            this.refreshResources();
                            renderErrorToast({
                                message: "ERRORS:RELOAD_OPTION_BASIC",
                                details: reason,
                                timestamp: Date.now()
                            });
                        });
                }
            })
            .catch((reason) => {
                this.props.removeLoadingMessage(loadingMsg);
                this.refreshResources();
                renderErrorToast({
                    message: "ERRORS:UPDATE_OPTION_BASIC",
                    details: reason,
                    timestamp: Date.now()
                });
            });
    }

    confirmOptionBasicsDelete = (dtos: OptionBasicDto[]): void => {
        const {getDeleteDependencyRequest} = this.state;

        if (getDeleteDependencyRequest && getDeleteDependencyRequest.canExecute()) {
            const loadingMsg = this.props.t("BASEOPTIONS:GET_DELETE_OPTION_BASIC_DEPENDENCY");
            this.props.addLoadingMessage(loadingMsg);

            let reqParam: GetOBDeleteDependencyParams = {
                optionBasicIds: dtos.filter((ob: OptionBasicDto) => this.props.client.DELETE_optionBasic(ob).canExecute()).map((ob: OptionBasicDto) => ob.objectId)
            };

            getDeleteDependencyRequest.execute(reqParam)
                .then((value: {[key: number]: OptionBasicPSLDependencyDto}) => {
                    this.props.removeLoadingMessage(loadingMsg);
                    this.setState({
                        showDeleteOBConfirmDialog: true,
                        deleteDependencies: value,
                        forDeleteDtos: dtos
                    });
                }).catch((reason) => {
                    this.props.removeLoadingMessage(loadingMsg);
                    renderErrorToast({
                        message: this.props.t("ERRORS:GET_DELETE_OPTION_BASIC_DEPENDENCY"),
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        } else {
            renderErrorToast({
                message: this.props.t("MISSING_ACCESS_RIGHTS"),
                timestamp: Date.now()
            });
        }
    }

    renderDeleteOBConfirmDialog = (): JSX.Element | null => {
        const {
            showDeleteOBConfirmDialog,
            forDeleteDtos,
            deleteDependencies
        } = this.state;

        if (showDeleteOBConfirmDialog && forDeleteDtos && forDeleteDtos.length > 0) {

            const canDeleteDtos = forDeleteDtos ? forDeleteDtos.filter((ob: OptionBasicDto) => this.props.client.DELETE_multiple_deletion(ob).canExecute()) : [];
            const cannotDeleteDtos = forDeleteDtos ? forDeleteDtos.filter((ob: OptionBasicDto) => !this.props.client.DELETE_multiple_deletion(ob).canExecute()) : [];

            return (
                <BaseOptionsDeleteConfirmDialog
                    canDeleteDtos={canDeleteDtos}
                    cannotDeleteDtos={cannotDeleteDtos}
                    deleteDependencies={deleteDependencies ? deleteDependencies : {}}
                    failedTodelete={this.state.failedTodelete}
                    onConfirm={() => {
                        this.deleteOptionBasics(canDeleteDtos);

                    }}
                    onCancel={() => this.setState({
                        forDeleteDtos: undefined,
                        deleteDependencies: undefined,
                        showDeleteOBConfirmDialog: false
                    })}
                />);
        } else {
            return null;
        }
    }

    deleteOptionBasics =  (dtos: OptionBasicDto[]): void => {
        const loadingMsg = this.props.t("DELETE_OPTION_BASIC");
        this.props.addLoadingMessage(loadingMsg);
        const canDeleteIds=dtos.map(p=>p.objectId);
        if(canDeleteIds.length > 0) {
            this.props.client.DELETE_multiple_deletion(dtos[0]).execute(canDeleteIds).then((data) => {
                this.props.removeLoadingMessage(loadingMsg);
                if(data.numberOfFailedDeleted > 0) {
                  this.setState({failedTodelete:data.numberOfFailedDeleted});
                } else {
                    this.setState({
                        forDeleteDtos: undefined,
                        deleteDependencies: undefined,
                        showDeleteOBConfirmDialog: false
                    });
                    if (this.state.selectedModelyear) {
                        // will reset the loading state of the view
                        this.requestOptionsBasicResource(this.state.selectedModelyear);
                    }
                }
            }).catch((reason) => {
                this.setState({selectedRows: []});
                this.props.removeLoadingMessage(loadingMsg);
                renderErrorToast({
                    message: "ERRORS:DELETE_OPTION_BASIC",
                    details: reason,
                    timestamp: Date.now()
                });
            });
        }

    }

    initPsl = (typefamilyId: number, optionBasicDtos: OptionBasicDto[]): void => {
        const {resourceLinks} = this.state;
        const {client} = this.props;

        if (!resourceLinks || !client.GET_optionBasicInitStatus(resourceLinks).canExecute()) {
            renderErrorToast({
                message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });
            this.props.removeLoadingMessage(this.processOBInitMsg);
            return;
        }

        const requestInitStatus = client.GET_optionBasicInitStatus(resourceLinks);
        let notInitializableOBs: OptionBasicDto[] = [];
        let initializableOBs: OptionBasicDto[] = [];
        let getOBInitStatusParam: GetOBInitStatusParams = {
            typeFamily: typefamilyId,
            optionBasicDtoIds: _.map(optionBasicDtos, (ob) => ob.objectId),
        };

        // First request OBs init status => false = are already initialized; true = can be initiliazed
        requestInitStatus.execute(getOBInitStatusParam)
            .then((value: {[key: number]: boolean}) => {
                Object.keys(value).map(key => {
                    if (value[key] === false) {
                        notInitializableOBs.push(_.filter(optionBasicDtos, (ob) => ob.objectId.toString() === key)[0]);
                    } else {
                        initializableOBs.push(_.filter(optionBasicDtos, (ob) => ob.objectId.toString() === key)[0]);
                    }
                });

                if (initializableOBs.length > 0) {
                    let preSelectedObWorkflows: SelectedWorkflowOB[] = [];
                    let selectObWorkflows: SelectWorkflowOB[] = [];

                    // Request available workflows
                    const requestWorkflows = client.GET_workflowsOption(resourceLinks);

                    if (!requestWorkflows.canExecute()) {
                        renderErrorToast({
                            message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                            timestamp: Date.now()
                        });
                        return;
                    }

                    let getWorkflowParam: GetWorkflowOptionParams = {
                        typeFamily: typefamilyId,
                        optionBasicDtoIds: _.map(initializableOBs, (ob) => ob.objectId),
                    };

                    requestWorkflows.execute(getWorkflowParam)
                        .then((response: {[key: number]: WorkflowDto[]}) => {
                            _.map(initializableOBs, (ob) => {

                                const optionBasicId: number = ob.objectId;
                                const workflows: WorkflowDto[] = response[ob.objectId];

                                if (workflows.length === 0) {
                                    preSelectedObWorkflows.push({optionBasic: ob, workflow: undefined} as SelectedWorkflowOB);

                                }
                                else if (workflows.length === 1) {
                                    preSelectedObWorkflows.push({optionBasic: ob, workflow: workflows[0]} as SelectedWorkflowOB);
                                }
                                else if (workflows.length > 1) {
                                    selectObWorkflows.push({
                                        optionBasic: ob,
                                        workflows: response[optionBasicId] ? response[optionBasicId].sort(sortWorkflowsByName) : []
                                    } as SelectWorkflowOB);
                                }
                            });

                            let initPSLOB: InitPSLOB = {
                                typeFamilyId: typefamilyId,
                                notInitializableOBs: notInitializableOBs,
                                preSelectedObWorkflows: preSelectedObWorkflows,
                                selectObWorkflows: selectObWorkflows,
                            };

                            this.setState({
                                initPSLOB: initPSLOB,
                                showInitPSLOBDialog: true,
                            });
                        }
                        );
                }
                else {
                    let initPSLOB: InitPSLOB = {
                        typeFamilyId: typefamilyId,
                        notInitializableOBs: notInitializableOBs,
                        preSelectedObWorkflows: [],
                        selectObWorkflows: [],
                    };

                    this.setState({
                        initPSLOB: initPSLOB,
                        showInitPSLOBDialog: true,
                    });
                }
            });
    }

    createOption(dto: SelectedWorkflowOB[], typefamilyId: number) {
        const {resourceLinks} = this.state;
        const {client} = this.props;

        if (!resourceLinks || !client.POST_option_with_context(resourceLinks)) {
            renderErrorToast({
                message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });
            return;
        }

        const request = client.POST_option_with_context(resourceLinks);
        const arrayToObject =
            dto.reduce((obj, item) => {obj[item.optionBasic.objectId] = item.workflow ? item.workflow.objectId : -1; return obj;}, {});
        let initDto: OptionInitDto = {
            typefamilyId: typefamilyId,
            optionBasicWorkflows: arrayToObject,
        };

        const loadingMsg = this.props.t("INIT_PSL");
        this.props.addLoadingMessage(loadingMsg);

        request.execute(initDto)
            .then((responseValue: {[key: string]: string}) => {
                this.props.removeLoadingMessage(loadingMsg);
                const errorDetails: string[] = [];
                const successInitOBs: string[] = [];

                dto.map((ob) => {
                    if (responseValue[ob.optionBasic.objectId]) {
                        errorDetails.push(this.props.t("ERRORS:INIT_PSL_ERROR") + ' ' +
                            ob.optionBasic.optionCode + '-' + ob.optionBasic.optionType + ': ' + responseValue[ob.optionBasic.objectId]);
                    } else {
                        successInitOBs.push(ob.optionBasic.optionCode + '-' + ob.optionBasic.optionType);
                    }
                });

                this.renderInitPSLResponse(errorDetails, successInitOBs, Object.keys(initDto.optionBasicWorkflows).length, Object.keys(responseValue).length);

                if (this.state.selectedModelyear) {
                    this.requestOptionsBasicResource(this.state.selectedModelyear);
                }
            })
            .catch((reason) => {
                this.props.removeLoadingMessage(loadingMsg);
                renderErrorToast({
                    message: "ERRORS:INIT_PSL",
                    details: reason,
                    timestamp: Date.now()
                });
            });
    }

    private renderInitPSLResponse(errorDetails: string[], successInitOBs: string[], totalOBCount: number, errorOBCount: number) {

        let successMsg;
        if (totalOBCount !== errorOBCount) {
            successMsg = (
                <>
                    <p><b>{(totalOBCount - errorOBCount) + ' ' + this.props.t("BASEOPTIONS:INIT_PSL_SUCCESS_MSG") + ':'}</b></p>
                    <ul>{successInitOBs.map((ob, idx) => <li key={'ob-init-' + idx}>{ob}</li>)}</ul>
                </>
            );
        }

        if (errorDetails.length > 0) {
            const errorMsg = (
                <>
                    <p><b>{errorOBCount + ' ' + this.props.t("ERRORS:INIT_PSL_FAIL_MSG") + ':'}</b></p>
                    <ul>{errorDetails.map((err, idx) => <li key={'err-init-' + idx}>{err}</li>)}</ul>
                </>
            );

            if (successInitOBs.length === 0) {
                renderErrorToast({
                    message: "ERRORS:INIT_PSL_ALL_FAIL",
                    details: errorMsg,
                    translatedDetails: true,
                    keepFormat: true,
                    timestamp: Date.now(),
                });
            } else {
                renderWarningToast({
                    message: "ERRORS:INIT_PSL_PARTIAL_FAIL",
                    details: (
                        <>
                            {successMsg}
                            {errorMsg}
                        </>
                    ),
                    translatedDetails: true,
                    timestamp: Date.now(),
                });
            }
        } else {
            renderInfoToast({
                message: "BASEOPTIONS:INIT_PSL_SUCCESS",
                details: successMsg,
                translatedDetails: true,
                keepFormat: true,
                timestamp: Date.now()
            });
        }
    }

    onModelyearSelectionChanged = (dto: ModelyearDto) => {
        const modelyearFromParam = this.getModelyearFromParam();
        if (modelyearFromParam && modelyearFromParam.objectId === dto.objectId) {
            // the url already point's to the selected model year
            return;
        }
        // the model year is part of the subdomain
        this.props.history.push(`/optionbasic/${dto.objectId}`);
    }

    onDeleteClicked = () => {
        if (this.state.selectedRows.length > 0) {
            this.confirmOptionBasicsDelete(this.state.selectedRows.map(row => row.optionBasicDto));
        }
    }

    /**
     * Displays an error and close dialogs based on the passed parameters
     *
     * @param error
     *          - the error that should be displayed inside a toast
     * @param selectDialog
     *          - if set true, sets the index of the select dialog to undefined
     * @param copyConflictDialog
     *          - if set true, removes (sets undefined) the BaseOptionsMYCopyConflictDialog
     *          component assigned to modelyearCopyConflictStatusDialog
     */
    private removeMYDialog(error: IError, selectDialog: boolean, copyConflictDialog: boolean): void {
        if (this.state.selectedModelyear) {
            if (selectDialog) {
                this.setState({modelyearDialogIndex: undefined});
            }
            if (copyConflictDialog) {
                this.setState({modelyearCopyConflictStatusDialog: undefined});
            }
            this.props.history.push(`/optionbasic/${this.state.selectedModelyear.objectId}`);
        } else {
            this.props.history.goBack();
        }
        renderErrorToast(error);
    }

    private handleMYCopy(sourceMY: ModelyearDto, targetMY: ModelyearDto, sourceOBForOverwrite?: OptionBasicMYCopyConflictDto[]) {
        const {t, baseOptionsAreaExtraLinks, client} = this.props;

        const postCopyRequest = client.POST_optionBasicMYCopy(baseOptionsAreaExtraLinks);
        if (postCopyRequest.canExecute()) {

            const srcStr = ColumnFactory.mj2str(sourceMY);
            const dstStr = ColumnFactory.mj2str(targetMY);
            const loadingMsg = t("COPY_SOURCE_TARGET", {sourceMy: srcStr, targetMy: dstStr});

            this.setState({modelyearCopyConflictStatusDialog: undefined});
            this.props.addLoadingMessage(loadingMsg);

            const copyParameters: OptionBasicMYCopyDto = {
                sourceModelyearId: sourceMY.objectId,
                targetModelyearId: targetMY.objectId,
                sourceOBsForOverwrite: sourceOBForOverwrite
            };

            postCopyRequest.execute(copyParameters)
                .then((value: OptionBasicMYCopySummaryDto) => {
                    const modelyearCopyResultDialog: JSX.Element = (
                        <Dialog
                            open={true}
                            title={t("COPY_MY_OB_SUMMARY")}
                            actions={[
                                (
                                    <Button
                                        key={"submitButton"}
                                        icon={"checkmark"}
                                        onClick={() => {
                                            this.setState({modelyearCopyResultDialog: undefined});
                                            this.onModelyearSelectionChanged(targetMY);
                                            this.requestOptionsBasicResource(targetMY);
                                        }}
                                    />
                                ), (
                                    <Button
                                        key={"closeButton"}
                                        icon={"ban"}
                                        onClick={() => {
                                            this.setState({modelyearCopyResultDialog: undefined});
                                            if (this.state.selectedModelyear && this.state.selectedModelyear.objectId === targetMY.objectId) {
                                                this.onModelyearSelectionChanged(this.state.selectedModelyear);
                                                this.refreshResources();
                                            } else if (this.state.selectedModelyear) {
                                                this.onModelyearSelectionChanged(this.state.selectedModelyear);
                                            }
                                        }}
                                    />
                                )
                            ]}
                        >
                            <div>
                                <p>{t("COPY_MY_OB_PROCESSED") + ': ' + (value.toProcessOBs ? value.toProcessOBs.length : '0')}</p>
                                <hr />
                                <p>{t("COPY_MY_OB_OVERWRITEN") + ': ' + (value.copiedWithOverwriteOBs ? value.copiedWithOverwriteOBs.length : '0')}</p>
                                <hr />
                                <p>{t("COPY_MY_OB_NO_CONFLICTS") + ': ' + (value.copiedWithoutConflictOBs ? value.copiedWithoutConflictOBs.length : '0')}</p>
                                <hr />
                                <p>{t("COPY_MY_OB_WITH_CONFLICTS") + ': ' + (value.inConflictOBs ? value.inConflictOBs.length : '0')}</p>
                                <hr />
                                <p>{t("COPY_MY_OB_ERRORS") + ': ' + (value.errorOBs ? value.errorOBs.length : '0')}</p>
                            </div>
                            <br />
                            <br />
                            <b>{t("LOAD_MODELYEAR", {modelyear: dstStr})}</b>
                        </Dialog>
                    );

                    this.props.removeLoadingMessage(loadingMsg);
                    this.setState({modelyearCopyResultDialog: modelyearCopyResultDialog});

                }).catch((reason) => {
                    this.props.removeLoadingMessage(loadingMsg);
                    const err: IError = {
                        message: "ERRORS:COPY_OPTIONBASICS",
                        translationOptions: {sourceMy: srcStr, targetMy: dstStr},
                        details: reason,
                        timestamp: Date.now()
                    };
                    this.removeMYDialog(err, false, true);
                });

        } else {
            this.removeMYDialog(
                {
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    timestamp: Date.now()
                },
                true,
                true
            );
        }
    }

    private renderMYCopyConflictStatusDialog(sourceMY: ModelyearDto, targetMY: ModelyearDto, value: OptionBasicMYCopyConflictDto[]): void {
        if (value.length > 0) {
            const dialog: JSX.Element = (
                <BaseOptionsMYCopyConflictDialog
                    onClose={() => this.setState({modelyearCopyConflictStatusDialog: undefined})}
                    onConfirm={(sourceOBForOverwrite: OptionBasicMYCopyConflictDto[]) => this.handleMYCopy(sourceMY, targetMY, sourceOBForOverwrite)}
                    copyConflictList={value}
                />
            );

            this.setState({modelyearCopyConflictStatusDialog: dialog});
        }
    }

    private renderHistoryDlg = () => {
        return (
            <HistoryDialog
                identifier={this.state.selectedRows ? this.state.selectedRows[0].optionBasicDto.optionCode || '' : ''}
                historyData={this.state.selectedItemFilteredHistoryData || []}
                categories={[...this.standardCategories || [], ...this.nonSerCategories || []]}
                t={this.props.t}
                dialogTitle={"OPTION_BASIC_HISTORY_TT"}
                onClose={() => this.setState({isShowHistoryDialog: false, selectedItemHistoryData: undefined})}
                filterValues={this.state.fieldKeyFilters || new Set<string>()}
                onChangeFilterValue={(fieldKey: string) => this.onChangeFilterValue(fieldKey)}
            />
        );
    }

    private onChangeFilterValue = (selectedFieldKey: string | undefined) => {
        if (selectedFieldKey !== undefined && selectedFieldKey !== '') {
            this.setState({
                              selectedItemFilteredHistoryData: this.state.selectedItemHistoryData
                                  && this.state.selectedItemHistoryData.filter(value => value.fieldKey === selectedFieldKey)
                          });
        } else {
            this.setState({
                              selectedItemFilteredHistoryData: this.state.selectedItemHistoryData
                          });
        }
    }

    private createDropdownFilterValues = () => {
        const fieldKeys: Set<string> = new Set<string>();

        if (this.state.selectedItemHistoryData) {
            fieldKeys.add("");
            this.state.selectedItemHistoryData.map(data => {
                if (data.fieldKey) {
                    fieldKeys.add(data.fieldKey);
                }
            });
        }

        this.setState({fieldKeyFilters: fieldKeys});
    }

    private requestBaseOptionHistory = () => {
        if (this.state.selectedRows) {
            const getHistoryRequest = this.props.client.GET_optionBasicSelfHistory(this.state.selectedRows[0].optionBasicDto);
            if (!getHistoryRequest.canExecute()) {
                renderErrorToast({
                    message: 'GLOBAL:MISSING_ACCESS_RIGHTS',
                    timestamp: Date.now()
                });
                return;
            }

            const requestLoadingMessage = this.props.t('GET_HISTORY');
            this.props.addLoadingMessage(requestLoadingMessage);
            const params = {
                language: this.props.userLanguage
            };
            getHistoryRequest.execute(params)
                .then((returnValue: HistoryDto[]) => {
                    this.setState({
                                      isShowHistoryDialog: true,
                                      selectedItemHistoryData: returnValue,
                                      selectedItemFilteredHistoryData: returnValue
                                  });

                    this.props.removeLoadingMessage(requestLoadingMessage);
                    this.createDropdownFilterValues();
                }).catch((reason: any) => {
                    this.props.removeLoadingMessage(requestLoadingMessage);
                    renderErrorToast({
                        message: 'ERRORS:GET_HISTORY',
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }
    }

    renderModelyearSelection = (modelyears: ResourceListOfModelyearDto, activeIndex?: number): JSX.Element => {
        const {t, baseOptionsAreaExtraLinks, client} = this.props;
        const canCopy = client.GET_optionBasicMYCopyConflict(baseOptionsAreaExtraLinks).canExecute()
            && client.POST_optionBasicMYCopy(baseOptionsAreaExtraLinks).canExecute();

        return (
            <ModelyearSelectDialog
                activeIndex={activeIndex}
                modelyears={modelyears}
                selectedItem={this.state.selectedModelyear}
                onLoadModelYear={(dto: ModelyearDto) => {
                    this.onModelyearSelectionChanged(dto);
                    this.setState({modelyearDialogIndex: undefined});
                }}
                onCopyModelyear={canCopy ? (src: ModelyearDto, dst: ModelyearDto) => {
                    const getMYCopyConflictStatusRequest = client.GET_optionBasicMYCopyConflict(baseOptionsAreaExtraLinks);
                    if (getMYCopyConflictStatusRequest.canExecute()) {

                        const srcStr = ColumnFactory.mj2str(src);
                        const dstStr = ColumnFactory.mj2str(dst);
                        const loadingMsg = t("COPY_SOURCE_TARGET", {sourceMy: srcStr, targetMy: dstStr});
                        this.props.addLoadingMessage(loadingMsg);

                        const copyParameters: GetOBMYCopyStatusParams = {
                            sourceModelyearId: src.objectId,
                            targetModelyearId: dst.objectId
                        };

                        getMYCopyConflictStatusRequest.execute(copyParameters)
                            .then((value: OptionBasicMYCopyConflictDto[]) => {
                                this.props.removeLoadingMessage(loadingMsg);
                                this.setState({modelyearDialogIndex: undefined});

                                if (value.length > 0) {
                                    this.renderMYCopyConflictStatusDialog(src, dst, value);
                                } else {
                                    this.handleMYCopy(src, dst);
                                }
                            })
                            .catch((reason) => {
                                this.props.removeLoadingMessage(loadingMsg);
                                const err: IError = {
                                    message: "ERRORS:COPY_OPTIONBASICS_GET_CONFLICTS",
                                    translationOptions: {sourceMy: srcStr, targetMy: dstStr},
                                    details: reason,
                                    timestamp: Date.now()
                                };
                                this.removeMYDialog(err, true, false);
                            });
                    } else {
                        this.removeMYDialog(
                            {
                                message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                                timestamp: Date.now()
                            },
                            true,
                            false
                        );
                    }
                }
                    :
                    () => this.removeMYDialog(
                        {
                            message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                            timestamp: Date.now()
                        },
                        true,
                        false
                    )
                }
                onClose={() => {
                    if (this.state.selectedModelyear) {
                        // the dialog was called from within the view;
                        // return to the previous model year
                        this.onModelyearSelectionChanged(this.state.selectedModelyear);
                        this.setState({modelyearDialogIndex: undefined});
                    } else {
                        // the dialog is called from outide the view;
                        // return to the StartView.
                        this.props.history.goBack();
                    }
                }}
            />
        );
    }

    private onCheckPCCDSyncronisation = () => {
        const {client} = this.props;
        const {resourceLinks} = this.state;
        const canCheck = resourceLinks && client.GET_checkPccdSynchronization(resourceLinks).canExecute();

        if (!canCheck) {

            renderErrorToast({
                message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });
            return;
        }

        this.props.addLoadingMessage(this.props.t("OPTIONS_VIEW:CHECK_PSL_PCCD_SYNC"));
        // @ts-ignore already checked
        const request = client.GET_checkPccdSynchronization(resourceLinks);
        request.execute()
            .then((value: any) => {
                this.setState({
                    showCheckPCCDSyncResultDlg: true,
                    checkPCCDSyncResult: value
                });
                this.props.removeLoadingMessage(this.props.t("OPTIONS_VIEW:CHECK_PSL_PCCD_SYNC"));
            })
            .catch((reason: any) => {
                renderErrorToast({
                    message: "ERRORS:CHECK_PSL_PCCD_SYNC_ERROR",
                    details: reason,
                    timestamp: Date.now()
                });
                this.props.removeLoadingMessage(this.props.t("OPTIONS_VIEW:CHECK_PSL_PCCD_SYNC"));
            });
    }

    renderHeader = (): JSX.Element => {
        const {resourceLinks, editMode, selectedRows} = this.state;
        const {baseOptionsAreaExtraLinks, t, switchHeaderMode} = this.props;

        const canInitPsl = resourceLinks !== undefined
            && this.props.client.GET_optionBasicInitStatus(resourceLinks).canExecute()
            && this.props.client.POST_option_with_context(resourceLinks).canExecute()
            && this.state.selectedRows.length > 0;
        const canCopyContext = this.props.client.GET_optionBasicMYCopyConflict(baseOptionsAreaExtraLinks).canExecute()
            && this.props.client.POST_optionBasicMYCopy(baseOptionsAreaExtraLinks).canExecute();
        const canCreate = this.state.postRequest && this.state.postRequest.canExecute();
        const canDelete = this.state.selectedRows.find(row => this.props.client.DELETE_optionBasic(row.optionBasicDto).canExecute()) !== undefined;
        const canEdit = this.state.editMode
            || this.state.rows.find(row => this.props.client.PATCH_optionBasic(row.optionBasicDto).canExecute()) !== undefined;
        const canGetHistory = this.state.selectedRows.length === 1
            && this.props.client.GET_optionBasicSelfHistory(this.state.selectedRows[0].optionBasicDto).canExecute();
        const hasNewButton = (canCreate && !this.state.editMode) || false;
        const hasCheckPCCDSyncronisationButton = resourceLinks ? this.props.client.GET_checkPccdSynchronization(resourceLinks).canExecute() : false;
        return (
            <BaseOptionsHeader
                switchHeaderMode={switchHeaderMode}
                viewName={VIEWNAME.BASICOPTIONVIEW}
                isSelected={true}
                hasAsisigmantsAction={true}
                hasNewButton={hasNewButton}
                hasEditButton={canEdit}
                hasReloadButton={!this.state.editMode}
                hasHistoryButton={!this.state.editMode}
                hasDeleteButton={canDelete && !this.state.editMode}
                hasInitPslButton={canInitPsl && !this.state.editMode}
                hasCheckPCCDSyncronisationButton={hasCheckPCCDSyncronisationButton}
                disableCheckPCCDSyncronisationButton={this.state.rows.length === 0}
                labelPslButton={t("INIT_PSL")}
                labelDeleteButton={t("DELETE_SELECTION")}
                labelHistoryButton={t('SHOW_HISTORY')}
                labelNewButton={selectedRows.length === 1 ? t("COPY_OPTION_BASIC") : t("NEW_OPTION_BASIC")}
                iconNewButton={selectedRows.length === 1 ? 'copy' : 'add'}
                labelEditButton={!editMode ? t("START_EDITING") : t("STOP_EDITING")}
                labelCheckPCCDSyncronisationButton={t("OPTIONS_VIEW:CHECK_PSL_PCCD_SYNC_BTN")}
                labelReloadButton={t("RELOAD")}
                inEditMode={editMode}
                selectedRows={selectedRows.length}
                onClickCopyYearButton={canCopyContext ? () => this.setState({modelyearDialogIndex: 1}) : undefined}
                onClickInitPslButton={canInitPsl ? () => this.setState({showPslCreationDialog: true}) : undefined}
                onClickNewButton={canCreate ? () => this.setState({showOptionBasicCreationDialog: true}) : undefined}
                onClickEditButton={canEdit ? () => this.setState({editMode: !editMode}) : undefined}
                onClickDeleteButton={canDelete ? this.onDeleteClicked : undefined}
                onClickReloadButton={() => {
                    if (this.state.selectedModelyear) {
                        this.requestOptionsBasicResource(this.state.selectedModelyear);
                        this.props.getWorkflows();
                    }
                }}
                disableHistoryButton={selectedRows.length !== 1}
                onClickHistoryButton={canGetHistory ? this.requestBaseOptionHistory : undefined}
                onClickCheckPCCDSyncronisationButton={this.onCheckPCCDSyncronisation}
            />
        );
    }

    renderOptionBasics = (): JSX.Element => {
        if (this.state.rows.length === 0) {
            return (<div className='no-data-message'> {this.props.t("NO_DATA")} </div>);
        }

        return (
            <BaseOptionsTableContainer
                userRoles={this.props.userRoles}
                columns={this.state.columns.filter((column: SelectableColumn) => column.visible)}
                standardCategories={this.standardCategories}
                nonSerCategories={this.nonSerCategories}
                rows={this.state.rows}
                selectedRows={this.state.selectedRows}
                editable={this.state.editMode}
                onRowSelectionChanged={(selectedRows: IBaseOptionsRow[]) => this.setState({selectedRows: selectedRows})}
                onUpdateOptionBasic={this.updateOptionBasic}
                client={this.props.client}
                optionTypes={this.state.optionTypes}
                onTriggerClick={(options:string[])=> {
                    this.setState({optionTypes:options});
                }}
                resourceLinks={this.state.resourceLinks}
            />
        );
    }

    renderSelectInitPslDlg = (): JSX.Element | null => {
        if (this.state.selectedRows.length === 0) {
            if (this.props.dynTableSelectedIdList.length > 0)
                this.props.setSelectedIdLists([]);
            this.setState({
                showPslCreationDialog: false,
                selectedRows: [],
            });
            return null;
        }

        const optionBasics = this.state.selectedRows.map(row => row.optionBasicDto);

        let typefamilies: TypefamilyDto[] = [];
        const {selectedModelyear} = this.state;

        if (selectedModelyear) {
            const tfRes = this.props.userTypefamiliesMap[selectedModelyear.mj1] || {};
            typefamilies = tfRes.elements ? tfRes.elements : [];
        }

        return (
            <SelectInitPslDialog
                optionBasics={optionBasics}
                typefamilies={typefamilies}
                onInitPsl={(typefamilyId: number, optionBasicDtos: OptionBasicDto[]) => {
                    this.props.addLoadingMessage(this.processOBInitMsg);
                    this.initPsl(typefamilyId, optionBasicDtos);
                    this.setState({showPslCreationDialog: false});
                }}
                onClose={() => {
                    this.setState({showPslCreationDialog: false});
                }}
            />
        );
    }

    renderInitPSLDlg = (): JSX.Element => {
        this.props.removeLoadingMessage(this.processOBInitMsg);

        return (
            <InitPSLDialog
                oBworkflows={this.state.initPSLOB ? this.state.initPSLOB.selectObWorkflows : []}
                notInitializableOBs={this.state.initPSLOB ? this.state.initPSLOB.notInitializableOBs : []}
                preSelectedWorkflows={this.state.initPSLOB ? this.state.initPSLOB.preSelectedObWorkflows : []}
                typeFamilyId={this.state.initPSLOB ? this.state.initPSLOB.typeFamilyId : -1}
                onSel={(dto: SelectedWorkflowOB[], typeFamilyId: number) => {
                    this.setState({showInitPSLOBDialog: false});
                    this.createOption(dto, typeFamilyId);
                }}
                onClose={() => {
                    this.setState({showInitPSLOBDialog: false});
                }}
            />
        );
    }

    renderAddOptionBasicDlg = (modelyear: ModelyearDto): JSX.Element => {
        const optionBasicPDiPList = this.props.optionBasicsPDiPList.sort((a, b) => a.optionCode.localeCompare(b.optionCode, 'en'));
        const unusedOptionBasicPDiPList = optionBasicPDiPList.filter(obPDiP =>
            this.state.rows.findIndex(row => row.optionCode.trim().toUpperCase() === obPDiP.optionCode.trim().toUpperCase()) === -1);
        const {resourceLinks} = this.state;
        return (
            <OptionBasicCreationDialog
                modelyear={modelyear}
                allOptionBasicPDiPList={optionBasicPDiPList}
                unusedOptionBasicPDiPList={unusedOptionBasicPDiPList}
                resourceLinks={resourceLinks}
                templateItem={this.state.selectedRows.length === 1 ? this.state.selectedRows[0] : undefined}
                onCancel={() => this.setState({showOptionBasicCreationDialog: false})}
                onSave={(newDto: OptionBasicDto) => {
                    this.setState({showOptionBasicCreationDialog: false});
                    this.addOptionBasic(newDto);
                }}
            />
        );
    }
    renderCheckPCCDSyncResultDlg = (): JSX.Element => {
        return (
            this.state.checkPCCDSyncResult ?
                (
                    <PCCDSyncDialog
                        result={this.state.checkPCCDSyncResult}
                        t={this.props.t}
                        onClose={() => this.setState({
                            showCheckPCCDSyncResultDlg: false,
                            checkPCCDSyncResult: undefined
                        })}
                        incompletePCCD={this.props.t("OPTIONS_VIEW:PSL_PCCD_INCOMPLETE")}
                        inCompleteDTL={this.props.t("OB_PCCD_INCOMPLETE_DTL")}
                        col1={this.props.t("GLOBAL:PRFAMILY")}
                        col2={this.props.t("GLOBAL:OPTIONS")}
                        completeDTL={this.props.t("OB_PCCD_COMPLETE_DTL")}
                        noDataDTL={this.props.t("OB_PCCD_NO_DATA_DTL")}
                        tabTitle={this.props.t("OPTIONS_VIEW:TAB_PSL_PCCD_CHECK_INDEX_1")}
                    />
                )
                : <></>
        );
    }

    render() {
        const {userModelyears, loadingMessages} = this.props;
        const {
            modelyearDialogIndex,
            showPslCreationDialog,
            showInitPSLOBDialog,
            showOptionBasicCreationDialog,
            modelyearCopyConflictStatusDialog,
            modelyearCopyResultDialog,
            selectedModelyear,
            showDeleteOBConfirmDialog,
            isShowHistoryDialog,
            showCheckPCCDSyncResultDlg
        } = this.state;
        const showModelyearsDialog =
            ((modelyearDialogIndex !== undefined) || !this.getModelyearFromParam()) &&
            (!loadingMessages || loadingMessages.length === 0);
        return (
            <ViewContainer className={"display--flex flex-direction--column"}>
                {
                    showModelyearsDialog &&
                    this.renderModelyearSelection(userModelyears, modelyearDialogIndex)
                }
                {this.renderHeader()}
                {
                    selectedModelyear &&
                    <ErrorBoundary>
                        {this.renderOptionBasics()}
                    </ErrorBoundary>
                }
                {
                    showOptionBasicCreationDialog &&
                    selectedModelyear &&
                    this.renderAddOptionBasicDlg(selectedModelyear)
                }
                {
                    showPslCreationDialog &&
                    this.renderSelectInitPslDlg()
                }
                {
                    showInitPSLOBDialog &&
                    this.renderInitPSLDlg()
                }
                {
                    showDeleteOBConfirmDialog &&
                    this.renderDeleteOBConfirmDialog()
                }
                <ErrorBoundary>
                    {showCheckPCCDSyncResultDlg && this.renderCheckPCCDSyncResultDlg()}
                </ErrorBoundary>
                {modelyearCopyConflictStatusDialog}
                {modelyearCopyResultDialog}
                <ErrorBoundary >
                    {isShowHistoryDialog && this.renderHistoryDlg()}
                </ErrorBoundary >
            </ViewContainer>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    switchHeaderMode: selectSwitchHeaderMode(state),
    userSettings: selectUserSettings(state),
    baseLinks: selectBaseLinks(state),
    optionBasicTableSort: selectOptionBasicTableSort(state),
    languageList: selectLanguageList(state),
    workflows: selectWorkflows(state),
    userModelyears: selectUserModelyears(state),
    client: selectClient(state),
    baseOptionsAreaExtraLinks: selectBaseOptionsAreaExtraLinks(state),
    userRoles: selectUserRoles(state),
    dynTableSelectedIdList: selectVirtualizedTableSelectedIdList(state),
    userTypefamiliesMap: selectUserTypefamiliesMap(state),
    optionBasicsPDiPList: selectOptionBasicsPDiPList(state),
    loadingMessages: selectLoadingMessages(state),
    userLanguage: selectLanguage(state)
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>, ownProps: IBaseOptionViewProps): IMapDispatchToProps => ({
    addTranslationLocation: (translation: ILocationTranslation) => dispatch(GeneralActions.AddTranslationLocation(translation)),
    setSelectedIdLists: (ids: string[]) => dispatch(GeneralActions.DynTableSetSelectedIdList(ids)),
    addRecentDocument: (appLink: IApplicationLink) => dispatch(GeneralActions.AddRecentDocument(appLink)),
    getWorkflows: () => dispatch(GeneralActions.GetWorkflows(ownProps.t)),
    receiveOBExtraLinks: (links: MenuDto) => dispatch(BaseOptionViewActions.ReceiveBaseOptionsAreaExtraLinksAction(links)),
    setTableSort: (sort: ITableSort) => dispatch(BaseOptionViewActions.SetOptionBasicTableSort(sort)),
    setSerCatgories: (dtos: CategoryTextDto[]) => dispatch(BaseOptionViewActions.SetSerCategoryDtos(dtos)),
    setNonSerCatgories: (dtos: CategoryTextDto[]) => dispatch(BaseOptionViewActions.SetNonSerCategoryDtos(dtos)),
    setDynTableReload: (flag: boolean) => dispatch(GeneralActions.DynTableReload(flag)),
    addLoadingMessage: (message: string) => dispatch(GeneralActions.AddLoadingMessage(message)),
    removeLoadingMessage: (message: string) => dispatch(GeneralActions.RemoveLoadingMessage(message)),
    getOBPDiPList: (menuDto: MenuDto, mj4: number) => dispatch(BaseOptionViewActions.GetOptionBasicPDiPList(ownProps.t, menuDto, mj4)),
});

export default compose<React.ComponentType<IOwnProps>>(
    translate(["BASEOPTIONS", "OPTIONS_VIEW", "INFO", "GLOBAL", "ERRORS", "HISTORY"]),
    connect<IMapStateToProps>(mapStateToProps, mapDispatchToProps)
)(BaseOptionView);



// WEBPACK FOOTER //
// ./src/views/BaseOptionsView/BaseOptionsView.tsx